import { isGrouped } from '../list-box/list-box.utils.js';

function defaultAutocompleteFilter(inputValue, options) {
  const escapedInputValue = inputValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  const filterRegex = new RegExp(escapedInputValue, 'i');
  if (inputValue === '') {
    return new Promise(resolve => {
      resolve(options);
    });
  }
  if (isGrouped(options)) {
    return new Promise(resolve => {
      resolve(options.reduce((acc, group) => {
        const filteredGroupOptions = group.options.filter(_option => {
          var _a;
          return _option.title.match(filterRegex) || ((_a = _option.subtitle) === null || _a === void 0 ? void 0 : _a.match(filterRegex));
        });
        if (filteredGroupOptions.length > 0) {
          acc.push(Object.assign(Object.assign({}, group), {
            options: filteredGroupOptions
          }));
        }
        return acc;
      }, []));
    });
  }
  return new Promise(resolve => {
    resolve(options.filter(option => {
      var _a;
      return option.title.match(filterRegex) || ((_a = option.subtitle) === null || _a === void 0 ? void 0 : _a.match(filterRegex));
    }));
  });
}

export { defaultAutocompleteFilter };
